/**
 * How long the announcement queue waits before writing to a live region, so a
 * state flipped twice in quick succession announces only where it landed.
 */
export const ANNOUNCEMENT_DEBOUNCE_MS = 300;

/**
 * How long a live region is left blank before the same text is written back.
 * A screen reader announces a content *change*, so rewriting the words already
 * there is silence.
 */
export const ANNOUNCEMENT_REPEAT_GAP_MS = 100;
